var Backbone = require('backbone'),
    _ = require('underscore'),
    NoteFilterState = require('../state/filterState');

/*
 * 'Base' notes collection from which document and page note collections extend.
 * Should create a separate class for the 'allNotes' collection used in this application --
 * eg: for the other collections, where aren't interested in definiting this.sortDir && this.comparator
 */

module.exports = Backbone.Collection.extend({

    comparators: require('./comparators'),

    initialize: function(models, options) {
        // required to ref the doc of the note ( could subclass )
        options && options.document && ( this.document = options.document );

    },
    /*
    *
    * Needs to be called before the allNotes collection is rendered in layout for the proper sort to be respected.
    * dir: asc/desc
    * */
    updateSort: function(sortType, dir) {

        this.sortDir = dir;
        this.comparator = this.comparators[sortType].sortFn;
        this.sort();

    },

    getUIModels: function() {
        return this.map( function(note) {
            return note.uiModel;
        });
    },

    /*
    * Entry point to set isVisible on the noteUi Models.
    * If options.fromViewerLoad, create a new filter model, otherwise
    * use the model passed in (from the notes module state).
    * A potential improvement would be to store the filterModel directly on here for clarity.
    * */
    setIsFiltered: function( noteFilterModel, options ) {

        if (options && options.fromViewerLoad) {
            noteFilterModel = new NoteFilterState();
            // (always set: falsely would be passed if provided -- it's a double negative )
            noteFilterModel.setHideActivityNotes( options.hideActivityNotes );
        }

        this.each( function(note) {
           note.uiModel.setIsFiltered( noteFilterModel.shouldFilterNote (note) );
        });

    },

    /*
    * Return the visible/unfiltered noteModels in the collection.
    * If noteModels is provided, just return the visible models from that subset.
    * */
    getVisibleNotes: function( noteModels ) {

        if ( !noteModels ) {
            return this.filter( function(note) {
                return !note.uiModel.isFiltered();
            });
        }

        return _.filter( noteModels, function(note) {
            return !note.uiModel.isFiltered();
        });

    },
    /*
    * Return the number of notes that would be visible in the UI.
    * The 'unfiltered notes'.
    * */
    getNumberOfVisibleNotes: function() {

        var visibleNotes = this.getVisibleNotes();
        return visibleNotes.length;

    },

    notesAreFiltered: function() {
        return this.getNumberOfVisibleNotes() < this.length;
    },

    getNotesOfPage: function(pageNumber) {

        return this.filter( function(note) {
            return note.pageNumber === pageNumber;
        });
    },

    getNotesOfGroupType: function(groupType) {
        return _.where( this.models, { noteTypeGroup: groupType } );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/notes.js
 ** module id = 271
 ** module chunks = 0
 **/